import React, { useState, useEffect } from "react";
import DrawerRight from "../ui/DrawerRight";
import { toast } from "react-toastify";
import { FaExternalLinkAlt } from "react-icons/fa";
import { useSelector } from "react-redux";
import Button from '@mui/material/Button';
import { BACKEND } from "../../config/configEnvs";
import axios from "axios";
import moment, { duration } from 'moment-timezone';


const DrawerCalendarioTareasAudiovisualesMeets = ({open, closeDrawer, info, refetch}) => {

  const user = useSelector((state) => state.auth?.user); // Usuario logeado

  const [canEdit, setCanEdit] = useState(false); // Permisos editor

  const [serviceData, setServiceData] = useState({}) // Data modificable

  const [eventType, setEventType] = useState("")
  
  const handleUpdateField = async (field, newStatus) => {
    setServiceData((prevData) => ({
      ...prevData,
      [field]: newStatus,
    }));
  }

  const submitData = async () => { // Enviar la info al servidor
    const infoToSend = serviceData?.isVisit ? {
      startDate: serviceData.startDate || null, 
      deliverDate: serviceData.deliverDate || null,
      limitDate: serviceData.limitDate || null,
      receptor: serviceData.receptor || "",
      address: serviceData.address || "",
      linkDrive: serviceData.linkDrive || "",
      linkAddress: serviceData.linkAddress || "",
      numberPeople: serviceData.numberPeople || 0,
      status: serviceData.status || "Finalizado",
      productionType: serviceData.productionType || ""
    } : {
      startDate: serviceData.startDate || null,
      deliverDate: serviceData.deliverDate || null,
      limitDate: serviceData.limitDate || null,
      linkMeet: serviceData.linkMeet || "",
      status: serviceData.status || "Finalizado",
      productionType: serviceData.productionType || ""
    }

    try {
      await axios.put(`${BACKEND}/api/tareasProyectos/${info.id}`, 
        infoToSend
      )
      toast.success("Información actualizada correctamente")
    } catch (error) {
      toast.error("Error al actualizar la información")
    }
  }

  useEffect(() => { // Permisos de editor
    if (info?.responsible?.id === user.id) {
      setCanEdit(true);
    }
    if (
      user?.puesto.toUpperCase() === "JEFE DE PROYECTOS" ||
      user?.subarea.toUpperCase() === "JEFE VENTAS" ||
      user?.puesto.toUpperCase() === "EJECUTIVO COMERCIAL" ||
      user?.puesto.toUpperCase() === "EJECUTIVO DE CUENTAS" ||
      user?.puesto.toUpperCase() === "JEFE COMERCIAL" || 
      user?.puesto.toUpperCase() === "GERENTE GENERAL" ||
      user?.puesto.toUpperCase() === "ASISTENTE"
    ) {
      setCanEdit(true);
    }
  }, [info]);

  useEffect(() => {
    if (info) {
      setEventType(info.isVisit ? "Visita audiovisual" : "Reunión meet")
      setServiceData(info)
    }
  }, [info]);

  const formatDateTimeForInput = (date) => { // Formatear la fecha para poder actualizar la hora correctamente
    if (!date) return ""; // Retornar vacío si no hay fecha
    return moment(date).format("YYYY-MM-DDTHH:mm");
  };

  return (

    <DrawerRight
      open={open}
      maxWidth={500}
      title={"Detalles de evento"}
      onClose={closeDrawer}
    >

      {eventType === "Visita audiovisual" ? (

        <div className="flex flex-col gap-6 p-6 bg-gray-100 rounded-lg shadow-lg">

          {/* Encabezado */}
          <div className="p-4 bg-blue-200 rounded-lg shadow-sm flex flex-col gap-1">
            <h1 className="text-xl font-bold text-blue-900">
              {info?.objective?.phase?.service?.cotizacion?.cliente?.nombreComercial} - {info.isVisit ? "Visita audiovisual" : "Meet"}
            </h1>
            <p className="text-sm font-medium text-blue-800">
              Servicio: {info?.objective?.phase?.service?.servicio?.name}
            </p>
            <p className="text-sm font-medium text-blue-800">
              ID del servicio: {info?.objective?.phase?.service?.id}
            </p>
          </div>

          {/* Información destacada de la tarea */}
          <div className="p-4 bg-yellow-100 border-l-4 border-yellow-500 rounded-lg shadow">
            <h2 className="text-sm font-bold text-yellow-800">Tarea</h2>
            <p className="text-xs font-medium text-yellow-700">
              {info?.task?.name}
            </p>
          </div>

          {/* Link al proyecto */}
          {user?.puesto?.toUpperCase() !== "GESTION ADMI" && (
            <div>
              <a
                href={`/home/seguimiento/${info?.objective?.phase?.service?.cotizacion?.cliente?.id}/${info?.objective?.phase?.service?.servicio?.name}/${serviceData.serviceId}`}
                target="_blank"
                rel="noopener noreferrer"
                className="flex flex-row justify-center text-sm items-center gap-2 font-bold text-blue-600 hover:underline"
              >
                Ir al Proyecto
                <FaExternalLinkAlt />
              </a>
            </div>
          )}

          {/* Campos de formulario */}
          <div className="flex flex-col gap-4">

            {/* Fecha y hora de llegada */}
            <div className="flex flex-row justify-between items-center">
              <span className="text-xs font-semibold text-gray-700">Fecha y hora de llegada:</span>
              <input
                type="datetime-local"
                className="w-[12rem] text-xs text-gray-700 bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 py-2"
                value={formatDateTimeForInput(serviceData.startDate)}
                disabled={!canEdit}
                onChange={(e) => handleUpdateField("startDate", e.target.value)}
              />
            </div>

            {/* Fecha y hora de salida */}
            <div className="flex flex-row justify-between items-center">
              <span className="text-xs font-semibold text-gray-700">Fecha y hora de salida:</span>
              <input
                type="datetime-local"
                className="w-[12rem] text-xs text-gray-700 bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 py-2"
                value={formatDateTimeForInput(serviceData.deliverDate)}
                disabled={!canEdit}
                onChange={(e) => handleUpdateField("deliverDate", e.target.value)}
              />
            </div>

            {/* Fecha y hora límite */}
            <div className="flex flex-row justify-between items-center">
              <span className="text-xs font-semibold text-gray-700">Fech límite establecida:</span>
              <input
                type="datetime-local"
                className="w-[12rem] text-xs text-gray-700 bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 py-2"
                value={formatDateTimeForInput(serviceData.limitDate)}
                disabled={!canEdit}
                onChange={(e) => handleUpdateField("limitDate", e.target.value)}
              /> 
            </div>

            <div className="flex flex-row justify-between items-center">
              <span className="text-xs font-semibold text-gray-700">Estado:</span>
              <select
                type="datetime-local"
                className="w-[12rem] text-xs text-gray-700 bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 py-2"
                value={serviceData.status}
                disabled={!canEdit}
                onChange={(e) => handleUpdateField("status", e.target.value)}
              >
                <option value="Pendiente">Pendiente</option>
                <option value="En proceso">En proceso</option>
                <option value="Finalizado">Finalizado</option>
                <option value="Declinado">Declinado</option>
                <option value="Con retraso">Con retraso</option>
                <option value="Incumplido">Incumplido</option>
                <option value="Eliminado">Eliminado</option>
              </select>
            </div>

            {/* Encargado en recepcionar */}
            <div className="flex flex-row justify-between items-center">
              <span className="text-xs font-semibold text-gray-700">Encargado en recepcionar:</span>
              <input
                type="text"
                placeholder="Receptor"
                className="w-[12rem] text-xs text-gray-700 bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 py-2"
                value={serviceData.receptor}
                disabled={!canEdit}
                onChange={(e) => handleUpdateField("receptor", e.target.value)}
              />
            </div>

            {/* Dirección */}
            <div className="flex flex-row justify-between items-center">
              <span className="text-xs font-semibold text-gray-700">Dirección:</span>
              <input
                type="text"
                placeholder="Dirección"
                className="w-[12rem] text-xs text-gray-700 bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 py-2"
                value={serviceData.address}
                disabled={!canEdit}
                onChange={(e) => handleUpdateField("address", e.target.value)}
              />
            </div>

            {/* Link de la dirección */}
            <div className="flex flex-row justify-between items-center">
              <span className="text-xs font-semibold text-gray-700">Link dirección:</span>
              <input
                type="text"
                placeholder="Link de la dirección"
                className="w-[12rem] text-xs text-gray-700 bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 py-2"
                value={serviceData.linkAddress}
                disabled={!canEdit}
                onChange={(e) => handleUpdateField("linkAddress", e.target.value)}
              />
            </div>

            {/* Link de Google Drive */}
            <div className="flex flex-row justify-between items-center">
              <span className="text-xs font-semibold text-gray-700">Link Google Drive con imágenes:</span>
              <input
                type="text"
                placeholder="Link del Drive imágenes"
                className="w-[12rem] text-xs text-gray-700 bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 py-2"
                value={serviceData.linkDrive}
                disabled={!canEdit}
                onChange={(e) => handleUpdateField("linkDrive", e.target.value)}
              />
            </div>

            {/* Número de personas */}
            <div className="flex flex-row justify-between items-center">
              <span className="text-xs font-semibold text-gray-700">Número de personas:</span>
              <input
                type="number"
                placeholder="Número de personas"
                className="w-[12rem] text-xs text-gray-700 bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 py-2"
                value={serviceData.numberPeople}
                disabled={!canEdit}
                onChange={(e) => handleUpdateField("numberPeople", e.target.value)}
              />
            </div>

            {/* Tipo de producción */}
            <div className="flex flex-row justify-between items-center">
              <span className="text-xs font-semibold text-gray-700">Tipo de producción:</span>
              <input
                type="text"
                placeholder="Tipo de producción"
                className="w-[12rem] text-xs text-gray-700 bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 py-2"
                value={serviceData.productionType}
                disabled={!canEdit}
                onChange={(e) => handleUpdateField("productionType", e.target.value)}
              />
            </div>

            {/* Responsable */}
            <div className="flex flex-row justify-between items-center">
              <span className="text-xs font-semibold text-gray-700">Responsable:</span>
              <div className="flex flex-row items-center gap-4">
                <span className="text-xs">{info?.responsible?.name}</span>
                <img
                  className="h-10 w-10 rounded-full"
                  src={
                    info?.responsible?.foto?.url
                      ? info.responsible.foto.url
                      : "/assets/images/avatars/avatar_25.jpg"
                  }
                  alt={info?.responsible?.name}
                />
              </div>
            </div>

          </div>

          <Button 
            variant="contained"
            sx={{
              fontWeight: "bold",
              fontFamily: "poppins",
              paddingBlock: "4px",
              backgroundColor: "#ff6400",
              transform: "all",
              animationDuration: "1000",
              textTransform: "none",
              borderRadius: "8px",
              '&:hover': {
                backgroundColor: "#bb4a03",
              }
            }}
            onClick={() => {
              submitData();
            }}
            
          >
            Actualizar
          </Button>

        </div>

      ) : (

        <div className="flex flex-col gap-3 p-6 bg-gray-100 rounded-lg shadow-lg">

          {/* Encabezado */}
          <div className="p-4 bg-blue-200 rounded-lg shadow-sm flex flex-col gap-1">
            <h1 className="text-xs font-bold text-blue-900">
              {info?.objective?.phase?.service?.cotizacion?.cliente?.nombreComercial} - {info?.isVisit ? "Visita audiovisual" : "Google Meet"}
            </h1>
            <p className="text-xs font-medium text-blue-800">
              Servicio: {info?.objective?.phase?.service?.servicio?.name}
            </p>
            <p className="text-xs font-medium text-blue-800">
              ID del servicio: {info?.objective?.phase?.service?.id}
            </p>
          </div>

          {/* Información destacada de la tarea */}
          <div className="p-4 bg-yellow-100 border-l-4 border-yellow-500 rounded-lg shadow">
            <h2 className="text-xs font-bold text-yellow-800">Tarea</h2>
            <p className="text-xs font-medium text-yellow-700">
              {info?.task?.name}
            </p>
          </div>

          {/* Resposnable */}
          <div className="p-4 flex flex-row justify-between items-center bg-green-100 border-l-4 border-green-500 rounded-lg shadow">
            
            <div className="flex flex-col items-center">
              <h2 className="text-xs font-bold text-green-800">Responsable</h2>
              <p className="text-xs font-medium text-green-700">
                {info?.responsible?.name}
              </p>
            </div>

            <div className="flex flex-col items-center">
              <img
                src={info?.responsible?.foto?.url}
                alt={info?.responsible?.name}
                className="h-10 w-10 rounded-full"
              />
            </div>
          </div>

          {/* Link al proyecto */}
          {user?.puesto?.toUpperCase() !== "GESTION ADMI" && (
            <div>
              <a
                href={`/home/seguimiento/${info?.objective?.phase?.service?.cotizacion?.cliente?.id}/${info?.objective?.phase?.service?.servicio?.name}/${serviceData.serviceId}`}
                target="_blank"
                rel="noopener noreferrer"
                className="flex flex-row justify-center text-xs items-center gap-2 font-bold text-blue-600 hover:underline"
              >
                Ir al Proyecto
                <FaExternalLinkAlt />
              </a>
            </div>
          )}

          {/* Historial de entregas */}
          <div className="">
            <div className="flex flex-col gap-4 bg-white">
              {info?.deliverHistorical && info?.deliverHistorical?.length > 0 ? info?.deliverHistorical?.map((d, i) => (
                <div key={i} className="rounded-md shadow-md border border-gray-300 p-3 gap-4 w-full">
                  <span className="text-xs font-semibold text-gray-700">Fecha entrega: {new Date(d.deliverDate).toLocaleDateString('es-ES', {
                    hour: '2-digit',
                    minute: '2-digit',
                    second: '2-digit',
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric',
                  })}</span>

                  <div className="flex flex-col gap-2 border-t border-gray-200 pt-2" >
                    <span className="text-xs font-semibold text-gray-700">Links de evidencia</span>
                    <ul className="list-disc ml-4 text-[10px] truncate">
                      {d.evidenceLinks.map((l, i) => (
                        <li key={i}>
                          <a href={l.link} target="_blank" rel="noopener noreferrer" className="text-blue-500 text-[10px] hover:underline">
                              {l.link}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <div className="flex flex-col gap-2">
                      <div className="flex flex-row justify-between items-center border-t border-gray-200 pt-2">
                        <span className="text-xs font-semibold text-gray-700">Comentarios responsable:</span>
                        <span className="text-[10px] text-gray-600 px-3">{d.workerNotes}</span>
                      </div>
                      <div className="flex flex-row justify-between items-center border-t border-gray-200 pt-2">
                        <span className="text-xs font-semibold text-gray-700">Revisado por:</span>
                        <span className="text-[10px] text-gray-600 px-3">{d.reviewedBy}</span>
                      </div>
                      <div className="flex flex-row justify-between items-center border-t border-gray-200 pt-2">
                        <span className="text-xs font-semibold text-gray-700">Comentarios jefe de área:</span>
                        <span className="text-[10px] text-gray-600 px-3">{d.bossNotes}</span>
                      </div>
                      <div className="flex flex-row justify-between items-center border-t border-gray-200 pt-2">
                        <span className="text-xs font-semibold text-gray-700">Estado:</span>
                        <span className="text-[10px] text-gray-600 px-3">{d.deliverStatus}</span>
                      </div>
                    </div>
                  </div>
                </div>
              )) : (
                <div className="flex flex-col gap-4 bg-white text-center h-24 justify-center items-center rounded-md shadow-md border border-gray-300">
                  <span className="text-xs font-semibold text-gray-400">No hay historial de entregas</span>
                </div>
              )}
            </div>
          </div>

        </div>

      )
    }

    </DrawerRight>
  );
};

export default DrawerCalendarioTareasAudiovisualesMeets;